"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VersionKeys = void 0;
var VersionKeys = {
  API: "@lce/local/api"
  /* API */
  ,
  SAVED_ADDRESS: "@lce/local/savedAddresses"
  /* SavedAddresses */
  ,
  TOKEN: "@lce/local/token"
  /* Token */
  ,
  UUID: "@lce/local/uuid"
  /* UUID */

};
exports.VersionKeys = VersionKeys;